// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Blog_invalidDataError__GUghE"};